module.exports = __webpack_public_path__ + "static/media/twitter-colored.189e0468.svg";